import { render } from "./MasukanSaran.vue?vue&type=template&id=73fa1931"
import script from "./MasukanSaran.vue?vue&type=script&lang=js"
export * from "./MasukanSaran.vue?vue&type=script&lang=js"

import "./MasukanSaran.vue?vue&type=style&index=0&id=73fa1931&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__